import React from 'react';
import { DAISY_SEAL_IMAGE, DAISY_SEAL_TOOLTIP } from '../lib/daisySeal';

interface DaisySealBadgeProps {
  size?: number;
  className?: string;
  title?: string;
}

/**
 * DAISY hoof wax seal — modal corner mark for ledger-cleared members.
 * PNG is brown seal only; blue aura is CSS on the outside.
 */
export const DaisySealBadge: React.FC<DaisySealBadgeProps> = ({
  size = 40,
  className = '',
  title = DAISY_SEAL_TOOLTIP,
}) => (
  <span
    className={`inline-flex items-center justify-center overflow-visible ${className}`}
    title={title}
    style={{ width: size, height: size }}
  >
    <img
      src={DAISY_SEAL_IMAGE}
      width={size}
      height={size}
      alt=""
      role="img"
      aria-label={title}
      loading="lazy"
      decoding="async"
      draggable={false}
      className="block object-contain select-none pointer-events-none bg-transparent overflow-visible"
      style={{
        width: size,
        height: size,
        filter:
          'drop-shadow(0 0 5px rgba(125, 211, 252, 0.9)) drop-shadow(0 0 12px rgba(56, 189, 248, 0.65)) drop-shadow(0 0 20px rgba(14, 165, 233, 0.35))',
      }}
    />
  </span>
);

export default DaisySealBadge;
